import SlideNext from './SlideNext';
import SliderPrev from './SliderPrev';
import MenuOpen from './MenuOpen';
import MenuContentLabelHover from './MenuContentLabelHover';
import EnterAge from './EnterAge';
import LoadDone from './LoadDone';
import { EnterRoute, LeaveRoute } from './routes';
import RailPictureHover from './RailPictureHover';
import InstagramRailPictureHover from './InstagramRailPictureHover';
import TextEnter from './TextEnter';
import LiveImage from './LiveImage';
import BlendDetailsInitial from './BlendDetailsInitial';
import WineDetailsInitial from './WineDetailsInitial';
import AwardsInitial from './AwardsInitial';
import TheOThersInitial from './TheOthersInitial';
import BlendDetailsIn from './BlendDetailsIn';
import WineDetailsIn from './WineDetailsIn';
import AwardsIn from './AwardsIn';
import THeOthersIn from './TheOthersIn';
import ShowcaseInitial from './ShowcaseInitial';
import ShowcaseIn from './ShowcaseIn';

const animations = new Map();

// General
animations.set('enter-route', EnterRoute);
animations.set('leave-route', LeaveRoute);
animations.set('slide-next', SlideNext);
animations.set('slide-prev', SliderPrev);
animations.set('menu-open', MenuOpen);
animations.set('menu-content-label-hover', MenuContentLabelHover);
animations.set('enter-age', EnterAge);
animations.set('load-done', LoadDone);
animations.set('rail-picture-hover', RailPictureHover);
animations.set('instagram-rail-picture-hover', InstagramRailPictureHover);
animations.set('text-enter', TextEnter);
animations.set('live-image', LiveImage);

animations.set('blend-details-initial', BlendDetailsInitial);
animations.set('wine-details-initial', WineDetailsInitial);
animations.set('awards-initial', AwardsInitial);
animations.set('the-others-initial', TheOThersInitial);
animations.set('showcase-initial', ShowcaseInitial);
animations.set('blend-details-in', BlendDetailsIn);
animations.set('wine-details-in', WineDetailsIn);
animations.set('awards-in', AwardsIn);
animations.set('the-others-in', THeOthersIn);
animations.set('showcase-in', ShowcaseIn);

export default animations;
